module.exports = __webpack_public_path__ + "img/auth-img.0c75e335.svg";